const randomBytes = () => (10 * Math.random() * Math.random() * Math.random())
  .toString(36)
  .substr(2, 9);

export default randomBytes;
